import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { History } from './model'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HistoryServiceService {
  url = `${environment.apiUrl}/history?hospital_id=${localStorage.getItem('hospital_id')}`;

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    private http : HttpClient
  ) { }

  getHistoryAll(): Observable<History[]>{
    return this.http.get<History[]>(this.url, this.httpOptions)
  }
}
